import { useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Img1 from '../../assets/images/home/carousel-img1.jpg';
import Img2 from '../../assets/images/home/carousel-img2.jpg';
import Img3 from '../../assets/images/home/carousel-img3.jpg';
import Img4 from '../../assets/images/home/carousel-img4.jpg';
import Img5 from '../../assets/images/home/carousel-img5.jpg';
import Img6 from '../../assets/images/home/carousel-img6.jpg';

import './styles.css';

function HomeCarousel() {
    
    // Mudar o aria-label padrão dos botões previous e next da lib do Carousel
    useEffect(() => {
        let previousSlide = document.getElementsByClassName('control-arrow control-prev');
        previousSlide[0].setAttribute('aria-label', 'Voltar para a imagem anterior do carrossel');

        let nextSlide = document.getElementsByClassName('control-arrow control-next');
        nextSlide[0].setAttribute('aria-label', 'Avançar para a próxima imagem do carrossel');
    }, []);

    return(
        <Carousel autoPlay interval={3000} showThumbs={false} showIndicators={false} infiniteLoop={true}>
            <div>
                <img src={Img1} alt="Esposa lendo os votos de casamento" />
            </div>
            <div>
                <img src={Img2} alt="Noiva segurando o buquê e sorrindo" />
            </div>
            <div>
                <img src={Img3} alt="Ensaio de casal no pôr do sol" />
            </div>
            <div>
                <img src={Img4} alt="Ensaio de casal no pôr do sol" />
            </div>
            <div>
                <img src={Img5} alt="Casal se beijando após casamento em frente ao Castelo de Itaipava" />
            </div>
            <div>
                <img src={Img6} alt="Vestido de noiva em making of de casamento" />
            </div>
        </Carousel>
    );
}

export default HomeCarousel;